import React from "react";
import Countdown from "react-countdown";
import { Link } from "react-router-dom";
import i18n from "../../../i18n";
import { BiddingModal } from "../../helpers/biddingModal";
import { toggleLike, toggleWishlist } from "../../../models/auctions";
import { AuctionShare } from "./auctionShare";
import swal from "sweetalert";
import { getLoggedUser } from "../../../state/user";
import { formatCurrency } from "../../../state/utils";
import { VisitNow } from "./visitNow";
import { SaudiRiyalLogo } from "../../logo/saudiLogo";
import CarouselAuctionDetails from "../../carousel/CarouselAuctionDetails";

let is_logged = localStorage.getItem("is_logged_in") ? true : false;
const user = getLoggedUser();



export class SimilarAuctionsCard extends React.Component {
    constructor() {
        super();
        this.state = {
            open_popup: false,
            wishlist: false,
            like: false,
            is_active_light_box: false,
            bidTimeStopped: false,
            now: () => {
                let time = new Date().toLocaleTimeString("en-US", {
                    timeZone: "Asia/Riyadh",
                });
                let dt = new Date().toISOString("en-US").split("T")[0];
                let newDt = dt + " " + time;
                newDt = new Date(newDt.replace(/-/g, "/"));
                return newDt;
            },
        };
        this.closeModal = this.closeModal.bind(this);
        this.addWishList = this.addWishList.bind(this);
        this.addLike = this.addLike.bind(this);
        this.incrementTime = this.incrementTime.bind(this);
    }

    componentDidMount() {
        this.setState({ like: this.props.auction.auction_liked });
        this.setState({ wishlist: this.props.auction.auction_wishlisted });
        if (this.props.auction) {
            setInterval(this.incrementTime, 1000);
        }
    }

    incrementTime() {
        let { auction } = this.props;
        if (!auction) {
            console.error("auction is undefined in props");
            return;
        }
        let dt = new Date(auction.server_time);
        dt.setSeconds(dt.getSeconds() + 1);
        auction.server_time = dt;
        this.setState({ auction });
    }

    closeModal() {
        this.setState({ open_popup: false });
    }

    async addWishList(wishlist) {
        if (is_logged) {
            const response = await toggleWishlist({
                auction_id: this.props.auctionId,
                wishlist,
            });
            if (response) {
                this.setState({ wishlist: wishlist });
            }
        }
    }

    async addLike(like) {
        if (is_logged) {
            const response = await toggleLike({
                auction_id: this.props.auctionId,
                like,
            });
            if (response) {
                this.setState({ like: like });
            }
        }
    }

    createDate(dt) {
        return dt ? new Date(dt.replace(/-/g, "/")) : null;
    }

    getStatusBadgeClass(status) {
        const statusClasses = {
            E: "status-expired",
            F: "status-featured",
            A: "status-active",
            U: "status-upcoming",
        };
        return `status-badge ${statusClasses[status] || "status-active"}`;
    }

    render() {
        let current_lng = localStorage.getItem("I18N_LANGUAGE");
        let auction = this.props.auction;
        let images = this.props.images;
        let img_src = process.env.PUBLIC_URL + "/assets/images/placeholder.jpg";

        if (images.length > 0) {
            img_src = images[0].image;
        }

        let key = this.props.key;

        let amount_label = "";
        if (this.props.type === "upcoming") {
            amount_label = i18n.t("start_bid_amount");
        } else if (this.props.type === "previous") {
            amount_label = i18n.t("last_bid_amount");
        } else {
            amount_label = i18n.t("current_amount");
        }

        let startDateAr = auction.start_date_ar;
        let endDateAr = auction.end_date_ar;

        let statusAr = auction.status_label;
        let disp_status = "";
        let statusClass = this.getStatusBadgeClass(statusAr?.status);

        if (statusAr && statusAr["status"]) {
            disp_status = current_lng === "ar" ? statusAr["ar"] : statusAr["en"];
        }

        let endTime = new Date(this.createDate(auction.start_date)).getTime();
        let aucEndTime = new Date(this.createDate(auction.end_date)).getTime();

        let end_time = endDateAr && endDateAr["time"] ? endDateAr["time"] : "";
        end_time = end_time.replace("PM", i18n.t("PM"));
        end_time = end_time.replace("AM", i18n.t("AM"));

        let start_time = startDateAr && startDateAr["time"] ? startDateAr["time"] : "";
        start_time = start_time.replace("PM", i18n.t("PM"));
        start_time = start_time.replace("AM", i18n.t("AM"));

        let guarantee_amount = Number(auction.guarantee_amount);
        let orgImage = "";
        if (
            auction &&
            auction.organizationDetails &&
            auction.organizationDetails.file_organization_image_full
        ) {
            orgImage = auction.organizationDetails.file_organization_image_full;
        }

        const currentDate = new Date();
        const auctionStartDate = new Date(auction.start_date);
        let can_show_end_clock = true;

        if (auctionStartDate > currentDate) {
            can_show_end_clock = false;
        }

        return (
            <React.Fragment key={this.props.key}>


                <div className="col-md-4 col-sm-6 col-xs-12 pt-3 auc-card-container m-auto">
                    <div className="modern-auction-card">
                        {/* Card Header with Image */}
                        <div className="card-header-modern">
                            {/* <img
                                src={img_src}
                                className="auction-image-modern"
                                alt=""
                                onClick={() => {
                                    this.props.getImagePopup(true, images);
                                }}
                            /> */}

                            <CarouselAuctionDetails images={images} />


                            {/* Status Badge */}
                            <span className={statusClass}>{disp_status}</span>

                            {/* Organization Badge */}
                            {orgImage && (
                                <img src={orgImage} alt="Organization" className="org-badge-modern" />
                            )}

                            {/* Days Remaining */}
                            {/* <div className="days-remaining-modern">
                                <i className="fa fa-calendar"></i>
                                <span>{auction.days_remaining}</span>
                            </div> */}

                            {/* Social Share */}
                            {/* <div className="social-share-modern">
                <AuctionShare auction={auction} />
              </div> */}
                        </div>

                        {/* Card Body */}
                        <div className="card-body-modern">
                            {/* Title */}
                            <Link
                                to={"/auction-details/" + this.props.auctionId}
                                className="auction-title-modern">
                                {current_lng === "ar" ? this.props.title_ar : this.props.title}
                            </Link>

                            {/* Interaction Bar */}
                            {/* <div className="interaction-bar-modern">
                                <button className="interaction-btn-modern">
                                    <i className="fa fa-eye"></i> {this.props.total_views}
                                </button>
                                <button
                                    className={`interaction-btn-modern ${this.state.wishlist ? 'active' : ''}`}
                                    onClick={(event) => {
                                        this.addWishList(!this.state.wishlist);
                                    }}
                                >
                                    <i className={this.state.wishlist ? "fa fa-heart" : "fa fa-heart-o"}></i>
                                </button>
                                <button
                                    className={`interaction-btn-modern ${this.state.like ? 'active' : ''}`}
                                    onClick={(event) => {
                                        this.addLike(!this.state.like);
                                    }}
                                >
                                    <i className={this.state.like ? "fa fa-thumbs-up" : "fa fa-thumbs-o-up"}></i>
                                </button>
                                <button className="interaction-btn-modern">
                                    {i18n.t("bid_counr")} #{auction.bid_count}
                                </button>

                                <a
                                    target="_blank"
                                    href={`https://www.google.com/maps?q=${auction.latitude},${auction.longitude}`}
                                    className={`interaction-btn-modern ${this.state.wishlist ? 'active' : ''}`}
                                >
                                    <i className="fa fa-map-marker"></i>
                                </a>
                            </div> */}

                            {/* Bid Time Status */}
                            {(auction.is_bid_time_ends || auction.status !== "A") && (
                                <div className="bid-ended">
                                    <i className="fa fa-times-circle me-2"></i>
                                    {i18n.t("bid_time_ends")}
                                </div>
                            )}

                            {/* Countdown Timers */}
                            {/* {auction.status === "A" &&
                                !auction.is_bid_time_ends &&
                                auction.end_date && (
                                    <Countdown
                                        date={endTime}
                                        renderer={renderer}
                                        onComplete={() => {
                                            this.setState({ bidTimeStopped: true });
                                        }}
                                        now={() => new Date(auction.server_time)}
                                    />
                                )}

                            {auction.status === "A" &&
                                !auction.is_bid_time_ends &&
                                auction.end_date &&
                                can_show_end_clock && (
                                    <Countdown
                                        date={aucEndTime}
                                        renderer={rendererEnds}
                                        onComplete={() => {
                                            this.setState({ bidTimeStopped: true });
                                        }}
                                        now={() => new Date(auction.server_time)}
                                    />
                                )} */}

                            {/* Amount Grid */}
                            <div className="amount-grid-modern">
                                {/* <div className="amount-card-modern">
                                    <div className="amount-label-modern">{i18n.t("start_bid_amount")}</div>
                                    <div className="amount-value-modern">
                                        {formatCurrency(auction.start_amount)} <SaudiRiyalLogo/>
                                    </div>
                                </div> */}
                                <div className="amount-card-modern">
                                    <div className="amount-label-modern">{amount_label}</div>
                                    <div className="amount-value-modern">
                                        {formatCurrency(auction.current_amount)} <SaudiRiyalLogo />
                                    </div>
                                </div>

                                <div className="amount-card-modern">
                                    <div className="amount-label-modern">{i18n.t("gurantee_amount")}</div>
                                    <div className="amount-value-modern">
                                        {formatCurrency(guarantee_amount)} <SaudiRiyalLogo />
                                    </div>
                                </div>


                                {/* <div className="amount-card-modern">
                                    <div className="amount-label-modern">{i18n.t("vat")}</div>
                                    <div className="amount-value-modern">{auction.vat || "0"}%</div>
                                </div> */}
                            </div>

                            {/* Visit Amount Section */}
                            {Number(auction.visit_amount) > 0 && (
                                <div className="visit-section-modern">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <strong>
                                                {i18n.t("visit_amount")}: {formatCurrency(auction.visit_amount)} <SaudiRiyalLogo />
                                            </strong>
                                        </div>
                                        {auction.is_visit_active && (
                                            <VisitNow
                                                amount={auction.visit_amount}
                                                type="sitevisit"
                                                id={auction.id}
                                                gid={auction.group}
                                                is_group={false}
                                                group={auction.group}
                                                main_class="btn btn-warning-custom btn-sm"
                                            />
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Date Section */}


                            {/* Final Approval Button */}
                            {/* <button className="btn final-approval-btn">
                                {i18n.t("final_approval_lbl")}
                            </button> */}

                            {/* Action Buttons */}
                            <div className="action-buttons-modern">
                                <Link
                                    to={"/auction-details/" + this.props.auctionId}
                                    className="btn btn-primary-custom flex-fill"
                                >
                                    <i className="fa fa-info-circle me-2"></i>
                                    {i18n.t("view_details")}
                                </Link>

                                {this.props.can_bid && auction.is_enrolled && (
                                    <button
                                        className="btn btn-warning-custom flex-fill"
                                        onClick={() => {
                                            if (
                                                is_logged &&
                                                !user.is_staff &&
                                                auction.is_staff_auction
                                            ) {
                                                swal(
                                                    i18n.t("un_authorized"),
                                                    i18n.t("non_staff_popup"),
                                                    "warning"
                                                );
                                                return;
                                            }
                                            this.setState({ open_popup: true });
                                        }}
                                    >
                                        <i className="fa fa-gavel me-2"></i>
                                        {i18n.t("bid_now")}
                                    </button>
                                )}

                                {/* {auction.status === "A" && !auction.is_enrolled && (
                                    <Link
                                        to={!is_logged ? "/login" : "/enroll/" + auction.id}
                                        className="btn btn-primary-custom flex-fill"
                                    >
                                        <i className="fa fa-user-plus me-2"></i>
                                        {i18n.t("enroll")}
                                    </Link>
                                )} */}
                            </div>
                        </div>
                    </div>
                </div>

                <BiddingModal
                    open_popup={this.state.open_popup}
                    closeModal={this.closeModal}
                    auction={auction}
                    lng={current_lng}
                    key={key}
                />
            </React.Fragment>
        );
    }
}